<template>
  <div class="boxFile" :class="{ 'uploading': loadingUpload }">
    <TextInput :hide-input="iValue" type="file" :label="label" accept="image/*" @changed="(file) => choosedFile(file)" />
    <div class="text-left mb-3" :style="{ marginTop: (iValue ? '-1rem' : 0) }">
      <img v-if="tempImage" :src="tempImage" alt="" :style="{ height: '80px' }" :class="{ 'full-width': fullWidth }" />
      <div v-if="iValue" class="mt-2">
        <b-button variant="outline-danger" size="sm" @click="deleteFile">Delete</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import './Styles/UploadImage.scss'
export default {
  props: {
    value: { type: String, default: null },
    label: { type: String, default: null },
    fullWidth: { type: Boolean, default: false }
  },
  data() {
    return {
      loadingUpload: false,
      tempImage: null
    }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue) }
    }
  },
  mounted() { this.tempImage = this.value },
  methods: {
    choosedFile(file) {
      this.loadingUpload = true
      let uploadForm = new FormData()
      uploadForm.append('file', file)
      this.$store
        .dispatch('image/uploadNonConvertImage', uploadForm)
        .then((response) => {
          this.iValue = response.url
          this.tempImage = response.url
          this.loadingUpload = false
        })
        .catch(() => this.loadingUpload = false)
      let reader = new FileReader()
      reader.onload = () => {}
      reader.readAsDataURL(file)
    },
    deleteFile() {
      this.iValue = null
      this.tempImage = null
    }
  }
}
</script>